var JSONResponse = /*@__PURE__*/ (function () {
    function JSONResponse(response) {
        if (typeof response === 'string') {
            this.response = JSON.parse(response);
        }
        else {
            this.response = response;
        }
    }
    JSONResponse.prototype.getResponse = function () {
        return this.response;
    };
    return JSONResponse;
}());
export { JSONResponse };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/core/utils/json-response.ts
// module id = null
// module chunks = 